<script>
import Header from '@/components/common/Header.vue';
import { mapGetters } from 'vuex';
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import InlineSvg from '@/components/common/InlineSvg.vue';
import VideoPlayerModal from '@/components/common/VideoPlayerModal.vue';
// import 'swiper/swiper-bundle.css';

export default {
  name: 'KeyPal2Instructions',
  components: {
    Header,
    // Swiper,
    // SwiperSlide,
    InlineSvg,
    VideoPlayerModal,
  },
  data() {
    return {
      showVideoModal: false,
      showComingSoon: false,
      comingSoonTimer: null,
      currentVideoIndex: 0,
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        touchStartPreventDefault: false,
      },
      tabs: [
        {
          label: 'keypalTwo.instructions.tabs.hardware',
          id: 1,
          sections: [
            {
              subTitle: 'keypalTwo.instructions.hardware.basic',
              videoList: [
                {
                  folderPath: 'device_features/basic_operations/power_on_off',
                  title: 'keypalTwo.instructions.hardware.power',
                  poster: '',
                },
                {
                  folderPath:
                    'device_features/basic_operations/language_selection',
                  title: 'keypalTwo.instructions.hardware.language',
                  poster: '',
                },
                {
                  folderPath:
                    'device_features/basic_operations/button_operation',
                  title: 'keypalTwo.instructions.hardware.button',
                  poster: '',
                },
              ],
            },
            {
              subTitle: 'keypalTwo.instructions.hardware.security',
              videoList: [
                {
                  folderPath:
                    'device_features/security_settings/passphrase_setup',
                  title: 'keypalTwo.instructions.hardware.passphrase',
                  poster: '',
                },
                {
                  folderPath:
                    'device_features/security_settings/security_settings_overview',
                  title: 'keypalTwo.instructions.hardware.securityOverview',
                  poster: '',
                },
                {
                  folderPath: 'device_features/security_settings/verify_device',
                  title: 'keypalTwo.instructions.hardware.verifyDevice',
                  poster: '',
                },
              ],
            },
            {
              subTitle: 'keypalTwo.instructions.hardware.asset',
              videoList: [
                {
                  folderPath: 'device_features/asset_management',
                  title: 'keypalTwo.instructions.hardware.asset',
                  poster: '',
                },
              ],
            },
          ],
        },
        {
          label: 'keypalTwo.instructions.tabs.activation',
          id: 2,
          sections: [
            {
              subTitle: 'keypalTwo.instructions.activation.create',
              videoList: [
                {
                  folderPath: 'device_tutorial/create_seed',
                  title: 'keypalTwo.instructions.activation.create',
                  poster: '',
                },
              ],
            },
            {
              subTitle: 'keypalTwo.instructions.activation.import',
              videoList: [
                {
                  folderPath: 'device_tutorial/import_seed/manual_import',
                  title: 'keypalTwo.instructions.activation.manualImport',
                  poster: '',
                },
                {
                  folderPath: 'device_tutorial/import_seed/keypal_card_import',
                  title: 'keypalTwo.instructions.activation.keypalCardImport',
                  poster: '',
                },
              ],
            },
            {
              subTitle: 'keypalTwo.instructions.activation.backup',
              videoList: [
                {
                  folderPath: 'device_tutorial/backup_seed/copy_steel_backup',
                  title: 'keypalTwo.instructions.activation.steelBackup',
                  poster: '',
                },
                {
                  folderPath: 'device_tutorial/backup_seed/keypal_card_backup',
                  title: 'keypalTwo.instructions.activation.keypalCardBackup',
                  poster: '',
                },
              ],
            },
          ],
        },
        {
          label: 'keypalTwo.instructions.tabs.connect',
          id: 3,
          sections: [
            {
              subTitle: 'keypalTwo.instructions.connect.bluetooth',
              videoList: [
                {
                  folderPath: 'connect_wallet/bluetooth_connect_tokenpocket',
                  title: 'keypalTwo.instructions.connect.bluetooth',
                  poster: '',
                },
              ],
            },
            {
              subTitle: 'keypalTwo.instructions.connect.qrConnect',
              videoList: [
                {
                  folderPath:
                    'connect_wallet/qr_connect/qr_connect_tokenpocket',
                  title: 'keypalTwo.instructions.connect.qrConnectTP',
                  poster: '',
                },
                {
                  folderPath: 'connect_wallet/qr_connect/qr_connect_metamask',
                  title: 'keypalTwo.instructions.connect.qrConnectMM',
                  poster: '',
                },
              ],
            },
            {
              subTitle: 'keypalTwo.instructions.connect.transferReceive',
              videoList: [
                {
                  folderPath:
                    'connect_wallet/transfer_receive/bluetooth_transfer',
                  title: 'keypalTwo.instructions.connect.bluetoothTransfer',
                  poster: '',
                },
                {
                  folderPath: 'connect_wallet/transfer_receive/qr_transfer',
                  title: 'keypalTwo.instructions.connect.qrTransfer',
                  poster: '',
                },
                {
                  folderPath: 'connect_wallet/transfer_receive/receive_via_app',
                  title: 'keypalTwo.instructions.connect.receiveApp',
                  poster: '',
                },
                {
                  folderPath:
                    'connect_wallet/transfer_receive/receive_via_device',
                  title: 'keypalTwo.instructions.connect.receiveHardware',
                  poster: '',
                },
              ],
            },
          ],
        },
        {
          label: 'keypalTwo.instructions.tabs.upgrade',
          id: 4,
          sections: [
            {
              subTitle: 'keypalTwo.instructions.tabs.upgrade',
              videoList: [
                {
                  folderPath: 'firmware_upgrade/web_firmware_upgrade',
                  title: 'keypalTwo.instructions.upgrade.web',
                  noVideo: true,
                  poster: '',
                },
                {
                  folderPath: 'firmware_upgrade/bluetooth_firmware_upgrade',
                  title: 'keypalTwo.instructions.upgrade.bluetooth',
                  noVideo: true,
                  poster: '',
                },
              ],
            },
          ],
        },
      ],

      currentTabId: 1,
      currentVideoList: [],
      currentSectionTitle: '',
      // 鼠标拖拽滚动相关
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      scrollableVideoLists: {},
      // 滑动切换相关
      slideDirection: '', // 'left' 或 'right'
      isSliding: false,
      previousTabId: 1,
      USE_CDN: true, // Set to true to use CDN, false for local public folder
    };
  },
  watch: {
    '$route.params.activeTab': {
      handler(val) {
        this.updateTabFromRoute(val);
      },
      immediate: true,
    },
    currentTabId(newVal, oldVal) {
      if (oldVal !== undefined) {
        // 判断滑动方向
        this.slideDirection = newVal > oldVal ? 'left' : 'right';
        this.isSliding = true;
        this.previousTabId = oldVal;

        // 动画结束后重置状态
        setTimeout(() => {
          this.isSliding = false;
          this.slideDirection = '';
          this.updateVideoListScrollState();
        }, 400); // 与 CSS transition 时间一致
      }
      this.$nextTick(this.updateVideoListScrollState);
    },
  },
  mounted() {
    this.$nextTick(this.updateVideoListScrollState);
    window.addEventListener('resize', this.updateVideoListScrollState);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateVideoListScrollState);
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    bannerPic() {
      return this.isDarkMode
        ? require('@/assets/images/keypal-two-instructions/banner-dark.svg')
        : require('@/assets/images/keypal-two-instructions/banner.svg');
    },
    troubleshootList() {
      // 语言代码映射
      const langMap = {
        zh: 'zh-cn',
        'zh-tw': 'zh-hk',
        en: 'en',
        ja: 'jp',
        ko: 'kr',
        fr: 'fr',
        es: 'es',
      };

      const currentLang = langMap[this.$i18n.locale] || 'en';

      return [
        {
          title: 'keypalTwo.instructions.upgrade.webTroubleshoot',
          link: `https://keypal.gitbook.io/${currentLang}/user-manual/keypal-2/firmware-upgrade/faq/via-website`,
        },
        {
          title: 'keypalTwo.instructions.upgrade.bluetoothTroubleshoot',
          link: `https://keypal.gitbook.io/${currentLang}/user-manual/keypal-2/firmware-upgrade/faq/via-bluetooth`,
        },
      ];
    },
  },
  methods: {
    getVideoListScrollKey(tabId, section) {
      return `${tabId}-${section.subTitle}`;
    },
    updateVideoListScrollState() {
      const videoLists = this.$refs.videoLists || [];
      videoLists.forEach((videoList) => {
        const key = videoList.dataset.scrollKey;
        const canScrollRight =
          videoList.scrollLeft + videoList.clientWidth <
          videoList.scrollWidth - 1;
        this.$set(this.scrollableVideoLists, key, canScrollRight);
      });
    },
    updateTabFromRoute(tabName) {
      switch (tabName) {
        case 'tutorial':
          this.currentTabId = 2;
          break;
        case 'connect':
          this.currentTabId = 3;
          break;
        case 'upgrade':
          this.currentTabId = 4;
          break;
        case 'features':
        default:
          this.currentTabId = 1;
          break;
      }
    },
    clickTab(id, event) {
      if (event) {
        this.scrollTabToCenter(event);
      }
      let targetPath = 'features';
      if (id === 2) targetPath = 'tutorial';
      if (id === 3) targetPath = 'connect';
      if (id === 4) targetPath = 'upgrade';

      if (this.$route.params.activeTab !== targetPath) {
        this.$router.push(`/keypal2/${targetPath}`);
      }
    },
    openVideoModal(section, videoIndex) {
      this.currentVideoIndex = videoIndex;
      this.currentSectionTitle = this.$t(section.subTitle);
      this.showVideoModal = true;
      // Store the current section's video list for the modal
      this.currentVideoList = section.videoList.map((v) => ({
        ...v,
        title: this.$t(v.title),
        url: this.getVideoUrl(v.folderPath),
        poster: this.getPosterUrl(v.folderPath),
      }));
    },
    showToast() {
      if (this.comingSoonTimer) {
        clearTimeout(this.comingSoonTimer);
      }
      this.showComingSoon = true;
      this.comingSoonTimer = setTimeout(() => {
        this.showComingSoon = false;
      }, 2000);
    },
    getVideoUrl(folderPath) {
      const langMap = {
        zh: 'zh-cn',
        'zh-tw': 'zh-hk',
        en: 'en',
        ja: 'ja',
        ko: 'ko',
        fr: 'fr',
        es: 'es',
      };
      const lang = langMap[this.$i18n.locale] || 'en';
      const filename = `${lang}.mp4`;

      if (this.USE_CDN) {
        return `https://tp-statics-hk.hkg.bcebos.com/keypal-2/${folderPath}/${filename}`;
      }
      return `${process.env.BASE_URL}keypal-2/${folderPath}/${filename}`;
    },
    getPosterUrl(folderPath) {
      if (this.USE_CDN) {
        return `https://tp-statics-hk.hkg.bcebos.com/keypal-2/${folderPath}/poster.png`;
      }
      return `${process.env.BASE_URL}keypal-2/${folderPath}/poster.png`;
    },
    scrollVideoToCenter(event, videoIndex) {
      // 获取被点击的视频项元素
      const videoItem = event.currentTarget;
      const videoList = videoItem.parentElement;
      if (!videoList) return;

      // 计算需要滚动的位置,使视频项居中
      const itemLeft = videoItem.offsetLeft;
      const itemWidth = videoItem.offsetWidth;
      const listWidth = videoList.offsetWidth;

      // 目标滚动位置 = 项目左边距 - (列表宽度 - 项目宽度) / 2
      const targetScroll = itemLeft - (listWidth - itemWidth) / 2;

      // 平滑滚动到目标位置
      videoList.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });
      this.$nextTick(this.updateVideoListScrollState);
    },
    scrollTabToCenter(event) {
      // 获取被点击的元素
      const tabItem = event.currentTarget;
      const tabList = tabItem.parentElement;
      if (!tabList) return;

      // 计算需要滚动的位置,使元素居中
      const itemLeft = tabItem.offsetLeft;
      const itemWidth = tabItem.offsetWidth;
      const listWidth = tabList.offsetWidth;

      // 目标滚动位置 = 项目左边距 - (列表宽度 - 项目宽度) / 2
      const targetScroll = itemLeft - (listWidth - itemWidth) / 2;

      // 平滑滚动到目标位置
      tabList.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });
    },
    closeVideoModal() {
      this.showVideoModal = false;
    },
    // 鼠标拖拽滚动相关方法
    handleMouseDown(e, tabId) {
      const container = e.currentTarget;
      this.isDragging = true;
      this.startX = e.pageX - container.offsetLeft;
      this.scrollLeft = container.scrollLeft;
      container.style.cursor = 'grabbing';
      container.style.userSelect = 'none';
    },
    handleMouseLeave(e) {
      if (this.isDragging) {
        this.isDragging = false;
        e.currentTarget.style.cursor = 'grab';
      }
    },
    handleMouseUp(e) {
      this.isDragging = false;
      e.currentTarget.style.cursor = 'grab';
      e.currentTarget.style.userSelect = 'auto';
      this.updateVideoListScrollState();
    },
    handleMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const container = e.currentTarget;
      const x = e.pageX - container.offsetLeft;
      const walk = (x - this.startX) * 2; // 滚动速度倍数
      container.scrollLeft = this.scrollLeft - walk;
      this.updateVideoListScrollState();
    },
    handleTroubleshootClick(item) {
      window.open(item.link, '_blank');
    },
  },
};
</script>

<template>
  <div class="keyPay2">
    <Header />
    <div class="content">
      <div class="banner">
        <div class="title-1">KeyPal</div>
        <div class="title-1">{{ $t('keypalTwo.instructions.title') }}</div>
        <div class="desc">
          {{ $t('keypalTwo.instructions.desc') }}
        </div>
        <img class="banner-pic" :src="bannerPic" alt="banner-pic" />
      </div>
      <div class="tabs">
        <div
          class="tab-item"
          :class="{ active: currentTabId === item.id }"
          v-for="item in tabs"
          :key="item.label + item.id"
          @click="clickTab(item.id, $event)"
        >
          {{ $t(item.label) }}
        </div>
      </div>
      <div class="tab-content-wrapper" :class="{ 'is-sliding': isSliding }">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          class="tab-content"
          :class="{
            active: currentTabId === tab.id,
            prev: previousTabId === tab.id && isSliding,
            'slide-from-right':
              isSliding && currentTabId === tab.id && slideDirection === 'left',
            'slide-from-left':
              isSliding &&
              currentTabId === tab.id &&
              slideDirection === 'right',
            'slide-to-left':
              isSliding &&
              previousTabId === tab.id &&
              slideDirection === 'left',
            'slide-to-right':
              isSliding &&
              previousTabId === tab.id &&
              slideDirection === 'right',
          }"
        >
          <div v-for="section in tab.sections" :key="section.subTitle">
            <div class="video-list-title">
              {{ $t(section.subTitle) }}
            </div>
            <div
              class="video-list-wrap"
              :class="{
                'has-scroll-more':
                  scrollableVideoLists[getVideoListScrollKey(tab.id, section)],
              }"
            >
              <div
                class="video-list"
                ref="videoLists"
                :data-scroll-key="getVideoListScrollKey(tab.id, section)"
                @mousedown="handleMouseDown($event, tab.id)"
                @mouseleave="handleMouseLeave"
                @mouseup="handleMouseUp"
                @mousemove="handleMouseMove"
                @scroll="updateVideoListScrollState"
              >
                <div
                  class="video-list-item"
                  v-for="(video, index) in section.videoList"
                  :key="section.subTitle + video.title"
                  @click="
                    scrollVideoToCenter($event, index);
                    video.noVideo
                      ? showToast()
                      : openVideoModal(section, index);
                  "
                >
                  <div class="poster">
                    <video
                      :src="getVideoUrl(video.folderPath)"
                      :poster="getPosterUrl(video.folderPath)"
                      class="poster-content"
                      muted
                      preload="metadata"
                      playsinline
                    ></video>
                  </div>
                  <div class="video-title">{{ $t(video.title) }}</div>
                  <InlineSvg
                    :src="
                      require('@/assets/images/keypal-two-instructions/play.svg')
                    "
                    class="play-btn"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Firmware Upgrade Troubleshooting Section -->
          <div v-if="tab.id === 4" class="troubleshoot-section">
            <div class="video-list-title">
              {{ $t('keypalTwo.instructions.upgrade.troubleshoot') }}
            </div>
            <div class="troubleshoot-list">
              <div
                class="troubleshoot-item"
                v-for="(item, index) in troubleshootList"
                :key="index"
                @click="handleTroubleshootClick(item)"
              >
                <div class="item-title">{{ $t(item.title) }}</div>
                <InlineSvg
                  :src="
                    require('@/assets/images/keypal-two-instructions/arrow-right.svg')
                  "
                  class="arrow-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Video Player Modal -->
    <VideoPlayerModal
      v-if="showVideoModal"
      :videoList="currentVideoList"
      :initialIndex="currentVideoIndex"
      :sectionTitle="currentSectionTitle"
      @close="closeVideoModal"
    />

    <!-- Coming Soon Toast -->
    <transition name="fade">
      <div class="custom-toast" v-if="showComingSoon">
        {{ $t('common.comingSoon') }}
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.keyPay2 {
  --video-list-fade-start: rgba(243, 244, 248, 0);
  --video-list-fade-mid: rgba(243, 244, 248, 0.58);
  --video-list-fade-end: var(--bg-3);

  :root[theme='dark'] & {
    --video-list-fade-start: rgba(0, 0, 0, 0);
    --video-list-fade-mid: rgba(0, 0, 0, 0.42);
    --video-list-fade-end: var(--bg-3);
  }

  ::v-deep .header {
    position: sticky;
    top: 0;
    width: 100%;
  }
  .content {
    overflow: hidden;
    padding: 0 0.32rem;
    .banner {
      position: relative;
      width: 100%;
      background: var(--bg-10);
      border-radius: 0.24rem;
      overflow: hidden;
      margin: 0.32rem 0 0.6rem;
      padding: 0.77rem 0 0 0.88rem;
      .title-1 {
        font-size: 0.52rem;
        font-weight: 700;
        color: var(--color-1);
        line-height: 0.65rem;
        margin-bottom: 0.12rem;
        display: flex;
        align-items: center;
        &:first-child::after {
          content: '2';
          display: inline-block;
          width: 0.43rem;
          height: 0.47rem;
          background: #2980fe;
          border-radius: 0.07rem;
          line-height: 0.46rem;
          text-align: center;
          font-size: 0.43rem;
          font-weight: 500;
          color: #ffffff;
          margin-left: 0.2rem;
        }
      }
      .desc {
        margin-top: 0.32rem;
        width: 4.52rem;
        font-size: 0.16rem;
        font-weight: 500;
        color: #9a9a9a;
        line-height: 0.24rem;
      }
    }
    @media screen and (min-width: 767.1px) {
      .banner {
        aspect-ratio: 1200/424;
        padding: 0.77rem 0 0 0.88rem;
        &-pic {
          width: 4.47rem;
          height: 2.52rem;
          position: absolute;
          top: 0.65rem;
          left: 6.38rem;
        }
      }
    }
    @media screen and (max-width: 767px) {
      padding: 0 0.4rem;
      .banner {
        aspect-ratio: 0.886;
        padding: 0.62rem 0.72rem;
        &-pic {
          width: 4.47rem;
          height: 2.52rem;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0.83rem;
        }
        .title-1 {
          font-size: 0.56rem;
          line-height: 0.68rem;
          margin-bottom: 0.14rem;
        }
        .desc {
          width: 100%;
          margin-top: 0.24rem;
          font-size: 0.24rem;
          line-height: 0.34rem;
        }
      }
    }
    .tabs {
      position: relative;
      display: flex;
      align-items: center;
      column-gap: 0.48rem;
      overflow-x: auto;
      overflow-y: hidden;
      margin: 0.6rem auto 0.56rem;
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }

      .tab-item {
        cursor: pointer;
        height: 0.56rem;
        padding: 0 0.32rem;
        font-size: 0.24rem;
        font-weight: 500;
        text-align: center;
        line-height: 0.56rem;
        border-radius: 0.11rem;
        color: var(--color-5);
        white-space: nowrap;
        transition: all 0.3s ease;

        &:hover:not(.active) {
          color: var(--color-1);
          background: var(--bg-11);
        }

        &.active {
          padding: 0 0.48rem;
          color: #ffffff;
          background: #2980fe;
          box-shadow: 0 0.04rem 0.12rem rgba(41, 128, 254, 0.3);
        }
      }
    }

    // 滑动切换容器
    .tab-content-wrapper {
      position: relative;
      overflow: hidden;
      width: calc(100% + 0.64rem);
      margin: 0 -0.32rem;
      padding: 0 0.32rem;

      @media screen and (max-width: 767px) {
        width: calc(100% + 0.8rem);
        margin: 0 -0.4rem;
        padding: 0 0.4rem;
      }
    }

    .tab-content {
      width: 100%;
      display: none;
      opacity: 0;

      &.active {
        display: block;
        opacity: 1;
      }

      &.prev {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
      }
    }

    // 滑动动画
    .is-sliding {
      .tab-content {
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
          opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);

        // 从右侧滑入 (向左切换)
        &.slide-from-right {
          transform: translateX(0);
          opacity: 1;
          animation: slideInFromRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        // 从左侧滑入 (向右切换)
        &.slide-from-left {
          transform: translateX(0);
          opacity: 1;
          animation: slideInFromLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        // 向左滑出
        &.slide-to-left {
          transform: translateX(-30%);
          opacity: 0;
        }

        // 向右滑出
        &.slide-to-right {
          transform: translateX(30%);
          opacity: 0;
        }
      }
    }

    @keyframes slideInFromRight {
      from {
        transform: translateX(30%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes slideInFromLeft {
      from {
        transform: translateX(-30%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .video {
      &-title {
        font-size: 0.16rem;
        font-weight: 600;
        color: var(--color-4);
        line-height: 0.24rem;
        margin-top: 0.16rem;
        max-width: 2.55rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: color 0.3s ease;
      }

      &-swiper {
        padding-bottom: 30px;

        &-slide {
          width: 3.19rem !important;
        }
      }

      &-list-wrap {
        position: relative;
        margin: 0 -0.3rem 0.24rem -0.3rem;

        &.has-scroll-more::after {
          content: '';
          position: absolute;
          top: 0.2rem;
          right: 0;
          width: 0.4rem;
          height: 2.16rem;
          pointer-events: none;
          z-index: 2;
          background: linear-gradient(
            90deg,
            var(--video-list-fade-start) 0%,
            var(--video-list-fade-mid) 74%,
            var(--video-list-fade-end) 100%
          );
        }
      }

      &-list {
        display: flex;
        overflow-x: auto;
        overflow-y: visible;
        column-gap: 0.16rem;
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
        padding: 0.2rem 0.3rem 0.38rem;
        cursor: grab;

        &::-webkit-scrollbar {
          height: 4px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
          background: var(--color-3);
          border-radius: 2px;

          &:hover {
            background: var(--color-4);
          }
        }

        &-title {
          font-size: 0.2rem;
          font-weight: 600;
          text-align: left;
          color: var(--color-4);
          line-height: 0.22rem;
          margin-bottom: 0;
        }
        &-item {
          position: relative;
          cursor: pointer;
          width: 3.19rem;
          height: 2.16rem;
          padding: 0.16rem;
          background: var(--bg-10);
          border-radius: 0.16rem;
          flex-shrink: 0;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-0.04rem);
            box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.1);

            .poster {
              &::after {
                opacity: 1;
              }
            }

            .play-btn {
              transform: scale(1.1);
              filter: drop-shadow(0 0.02rem 0.08rem rgba(41, 128, 254, 0.4));
            }

            .video-title {
              color: #2980fe;
            }
          }

          &:active {
            transform: translateY(0);
          }

          .poster {
            width: 2.87rem;
            height: 1.4rem;
            border-radius: 0.08rem;
            position: relative;
            overflow: hidden;

            .poster-content {
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
            }

            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(
                135deg,
                rgba(41, 128, 254, 0.3) 0%,
                rgba(118, 75, 162, 0.3) 100%
              );
              opacity: 0;
              transition: opacity 0.3s ease;
            }
          }

          .play-btn {
            color: var(--color-1);
            position: absolute;
            width: 0.32rem;
            height: 0.32rem;
            right: 0.16rem;
            bottom: 0.16rem;
            transition: all 0.3s ease;
            filter: drop-shadow(0 0.02rem 0.04rem rgba(0, 0, 0, 0.2));
          }
        }

        @media screen and (max-width: 767px) {
          flex-wrap: wrap;
          overflow-x: visible;
          scrollbar-width: none;

          &::-webkit-scrollbar {
            display: none;
          }

          &-item {
            width: calc(50% - 0.08rem);
            height: auto;
            margin-bottom: 0.16rem;

            .poster {
              width: 100%;
              height: auto;
              aspect-ratio: 287/140;
            }
          }
        }
      }
    }

    .troubleshoot-section {
      margin-top: 0.2rem;
      margin-bottom: 0.56rem;

      .troubleshoot-list {
        margin-top: 0.2rem;
        display: flex;
        flex-direction: column;
        gap: 0.16rem;
      }

      .troubleshoot-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.24rem;
        background: var(--bg-10);
        border-radius: 0.16rem;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: var(--bg-11);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }

        .item-title {
          font-size: 0.16rem;
          font-weight: 600;
          color: var(--color-1);
        }

        .arrow-icon {
          width: 0.24rem;
          height: 0.24rem;
          color: var(--color-5);
        }
      }
    }
  }

  .custom-toast {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    pointer-events: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translate(-50%, -60%);
  }
}
</style>
